import React from "react";

class NotFound extends React.Component {
  render() {
    return <div></div>;
  }
}

export default NotFound;
